import React from 'react';
import { FaLeaf, FaShieldAlt, FaTruck, FaAward, FaPhoneAlt, FaCheckCircle } from 'react-icons/fa';
import '../styles/Features.css';

const Features = () => {
  const features = [
    {
      icon: <FaLeaf />,
      title: '100% Natural',
      description: 'All our products are sourced from organic farms with no artificial additives or preservatives'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Lab Tested',
      description: 'Every product undergoes rigorous quality testing to ensure purity and safety'
    },
    {
      icon: <FaTruck />,
      title: 'Free Delivery',
      description: 'Enjoy free shipping on all orders above Rs. 3000 across Pakistan'
    },
    {
      icon: <FaAward />,
      title: 'Premium Quality',
      description: 'We maintain the highest standards of quality in all our products'
    },
    {
      icon: <FaPhoneAlt />,
      title: '24/7 Support',
      description: 'Our customer support team is always ready to assist you'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Authentic Products',
      description: 'Guaranteed authentic products with full transparency in sourcing'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-title">
          <h2>Why Choose Dairyzar?</h2>
          <p>Your trusted partner for pure and natural products</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="testimonial-section">
          <h3 className="testimonial-title">What Our Customers Say</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "The desi ghee is absolutely pure and authentic. You can taste the difference! Highly recommended."
              </p>
              <p className="customer-name">- Fatima Khan, Karachi</p>
            </div>
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "Best quality shilajit I've found in Pakistan. Fast delivery and great customer service."
              </p>
              <p className="customer-name">- Ahmed Ali, Lahore</p>
            </div>
            <div className="testimonial-card">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "The honey is pure and natural. My family loves it. Will definitely order again!"
              </p>
              <p className="customer-name">- Ayesha Malik, Islamabad</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;